import { Icon } from '../Icon';
import { IconMap } from '../IconMap';

interface LabelProps {
  text: string;
  isRequired?: boolean;
  iconName?: keyof typeof IconMap;
  iconSize?: number;
  className?: string;
}

export const Label = ({ text, isRequired = false, iconName, iconSize = 16, className = '' }: LabelProps) => {
  return (
    <label className={`items-center text-md font-[600} ${className}`}>
      {isRequired && <span className="text-error-300">*</span>}
      {text}
      {iconName && <Icon name={iconName} size={iconSize} className="text-secondary-300" />}
    </label>
  );
};
